export default __webpack_public_path__ + "static/media/docker.be4c9e83.png";